import { useSelector } from "react-redux"
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom"
import { JourneyIntro } from "components/views/fle/journey/JourneyIntro"
import { JourneyWhereAreYou } from "components/views/fle/journey/JourneyWhereAreYou"
import { JourneyLearnMoreInterest } from "components/views/fle/journey/JourneyLearnMoreInterest"
import { JourneyLearnMoreSomethingElse } from "components/views/fle/journey/JourneyLearnMoreSomethingElse"
import { JourneyNextStepInterest } from "components/views/fle/journey/JourneyNextStepInterest"
import { JourneyInitialConsult } from "components/views/fle/journey/JourneyInitialConsult"
import { JourneyNextStepSomethingElse } from "components/views/fle/journey/JourneyNextStepSomethingElse"
import { JourneyTalkedToDoctor } from "components/views/fle/journey/JourneyTalkedToDoctor"
import { JourneyReceivingCareInterest } from "components/views/fle/journey/JourneyReceivingCareInterest"
import { JourneyReceivingCareSomethingElse } from "components/views/fle/journey/JourneyReceivingCareSomethingElse"
import { HowLongTrying } from "components/views/fle/HowLongTrying"
import React from "react"
import { getJourney } from "../../../../reducers/userInfo"
import { JourneyPaths } from "./JourneyPaths"
import Journeys from "../../../../utils/Journeys"
import { JourneyStartedSeeingDoctor } from "./JourneyStartedSeeingDoctor"

const GetBackPathForInitialConsultOrTalkedToDoctor = (journey) => {
  const JourneyToJourneyPath = {
    [Journeys.LEARN_MORE]: JourneyPaths.LEARN_MORE,
    [Journeys.READY_FOR_NEXT_STEP]: JourneyPaths.NEXT_STEP
  }
  return JourneyToJourneyPath[journey]
}

const JourneyRouter = () => {
  const history = useHistory()
  const location = useLocation()
  const journey = useSelector(getJourney)

  return (
    <Switch>
      <Route exact path="/fle/journey">
        <Redirect to="/fle/journey/intro" />
      </Route>
      <Route exact path="/fle/journey/intro">
        <JourneyIntro next="/fle/journey/where-are-you" skip="/fle/done" location={location} history={history} />
      </Route>
      <Route exact path="/fle/journey/where-are-you">
        <JourneyWhereAreYou skip={JourneyPaths.DONE} history={history} />
      </Route>
      <Route exact path={JourneyPaths.LEARN_MORE}>
        <JourneyLearnMoreInterest toDone={JourneyPaths.DONE} history={history} />
      </Route>
      <Route exact path="/fle/journey/learn-more/something-else">
        <JourneyLearnMoreSomethingElse history={history} />
      </Route>
      <Route exact path={JourneyPaths.NEXT_STEP}>
        <JourneyNextStepInterest toDone={JourneyPaths.DONE} history={history} />
      </Route>
      <Route exact path={JourneyPaths.INITIAL_CONSULTATION}>
        <JourneyInitialConsult
          back={GetBackPathForInitialConsultOrTalkedToDoctor(journey)}
          next={JourneyPaths.DONE}
          history={history}
        />
      </Route>
      <Route exact path="/fle/journey/next-step/something-else">
        <JourneyNextStepSomethingElse history={history} />
      </Route>
      <Route exact path={JourneyPaths.TALKED_TO_DOCTOR}>
        <JourneyTalkedToDoctor
          back={GetBackPathForInitialConsultOrTalkedToDoctor(journey)}
          next={JourneyPaths.DONE}
          history={history}
        />
      </Route>
      <Route exact path="/fle/journey/receiving-care">
        <JourneyReceivingCareInterest history={history} />
      </Route>
      <Route exact path="/fle/journey/receiving-care/something-else">
        <JourneyReceivingCareSomethingElse history={history} />
      </Route>
      <Route exact path="/fle/journey/trying-to-get-pregnant">
        <HowLongTrying next={JourneyPaths.TALKED_TO_DOCTOR} />
      </Route>
      <Route exact path={JourneyPaths.STARTED_SEEING_DOCTOR}>
        <JourneyStartedSeeingDoctor history={history} />
      </Route>
    </Switch>
  )
}

export { JourneyRouter }
